import { Formik } from "formik";
import { useContext, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useOutletContext } from "react-router-dom";
import { AuthContext } from "../../../../components/AuthWrapper";
import { FormNavButtons } from "../../../../components/Additional/FromButtons";
import { FormHeading } from "../../../../components/Additional/FormHeading";
import { FormContext } from "../../../../components/Additional/FormWrapper";
import { VerticalForm } from "../../../../components/Additional/VerticalForm";
import { constructSubmitValue } from "../FormValues";
import { CreateFormSubmission, FileParameter } from "../../../../api/client";
import { EntireFormInterface } from "../Helpers";

export function Confirmation(): JSX.Element {
  const { client, state, setStudent }: AuthContext = useOutletContext();
  const { formData, isCreating, onSubmit } = useContext(FormContext);
  const [submitting, setSubmitting] = useState<boolean>(false);

  const navigate = useNavigate();

  return (
    <Formik
      initialValues={formData as EntireFormInterface}
      onSubmit={(values) => {

        onSubmit(values);

        if (values.submitAction == 'back') {
          return;
        }

        setSubmitting(true);
        let err;
        // Gather data from the form
        const data = constructSubmitValue(values);
        if ('submitAction' in data) {
          delete data['submitAction'];
        }

        const model = new CreateFormSubmission({
          contents: data,
          userId: state.user?.id,
        });

        // Files
        const files: FileParameter[] = [];

        const resumeWasNotAdded = (!('resume' in values) || !(values['resume'] instanceof File));

        // If resume is there let's get it
        if (!resumeWasNotAdded) {
          // The resule file
          const file = (values as any)['resume'] as File;

          // Add it to files array (not neccessary needed here, but would be useful if we had several files)
          files.push({
            fileName: "resume",
            data: file
          });
        }
        
        // Json file with the model
        const modelFile: FileParameter = {
          data: new Blob([JSON.stringify(model)]),
          fileName: '__model__.json',
        };
        // Merge model data and resume
        const requestFiles = [modelFile].concat(files ?? []);

        // Make the backend requests
        if (isCreating) {

          toast.promise(
            (async () => {
              const studentProfile = await client!.student_SubmitStudentProfile(requestFiles);
              if (setStudent) {
                setStudent(studentProfile);
                navigate(`/profile/${studentProfile?.id}`);
              }
            })(),
            {
              loading: 'Submitting...',
              error(e) {
                err = e;
                return `Failed to process request: ${e?.message ?? e}`;
              },
              success: 'Successfully Created the Profile!'
            }
          ).finally(() => setSubmitting(false));
        } else {
          toast.promise(
            (async () => {
              client!.student_EditStudentProfile(requestFiles).then((student) => {
                if (setStudent) {
                  setStudent(student);
                  navigate(`/profile/${student?.id}`);
                }
              }).catch(() => {
                toast.error('Error to edit your student profile');
              }).finally(() => {
                setSubmitting(false);
              });
            })(),
            {
              loading: 'Submitting...',
              error(e) {
                err = e;
                return `Failed to process request: ${e}`;
              },
              success: 'Successfully Edited the Profile!'
            }
          );
        }
      }}
    >
      <VerticalForm>
        <FormHeading>Submission</FormHeading>
        <p>
          <b>You're there!</b> Thank you for taking the time to complete your profile setup.
        </p>
        <br />
        <p>
          <b>Click "Submit" to finalize your profile and start your journey with the Office of National Scholars.</b>
          {' '}
          Remember, you can always update your information in the future to ensure your profile
          remains accurate and relevant.
        </p>
        <FormNavButtons submitting={submitting} />
      </VerticalForm>
    </Formik >
  );
}
